import React from 'react';
import { QStack, QButton, QBox, QIcon, QText } from '@qualio/ui-components';
import * as DisplayStrings from '../../../../displayStrings';

const QObjectFormFieldLabel = ({
  label,
  showEditBtn,
  onEditBtnClick,
  showAlertIcon = false,
  showRequired = false,
}: {
  label: string | undefined;
  showEditBtn: boolean;
  onEditBtnClick: React.Dispatch<React.SetStateAction<boolean>>;
  showAlertIcon?: boolean;
  showRequired?: boolean;
}) => {
  return (
    <QStack direction="row">
      <QStack direction="row" alignItems="center">
        <QText fontWeight="semibold" fontSize="sm">
          {label}
        </QText>
        {showRequired && (
          <QText fontWeight="semibold" color="red.500">
            *
          </QText>
        )}
        {showAlertIcon && <QIcon iconName="AlertTriangle" color="yellow.500" />}
      </QStack>
      {showEditBtn && (
        <QBox>
          <QButton variant="link" onClick={() => onEditBtnClick(true)}>
            {DisplayStrings.Edit}
          </QButton>
        </QBox>
      )}
    </QStack>
  );
};
export default QObjectFormFieldLabel;
